import React from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDownOutline, chevronUpOutline } from 'ionicons/icons';
import TextMarquee from 'components/TextMarquee';
import {
  LeaderboardPlayerName,
  isPrivateLeaderboardPlayerName,
} from './PrivateLeaderboardPlayerLabel';

interface LeaderboardCurrentUserCardProps {
  player: string;
  avatarText: string;
  rank: number;
  metricLabel: string;
  metricValue: string;
}

const LeaderboardCurrentUserCard: React.FC<LeaderboardCurrentUserCardProps> = ({
  player,
  avatarText,
  rank,
  metricLabel,
  metricValue,
}) => {
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="leaderboard-current-user-section" role="region" aria-label="My Position">
      <button
        className="leaderboard-current-user-section__header"
        onClick={() => setCollapsed((c) => !c)}
        aria-expanded={!collapsed}
      >
        <span className="leaderboard-current-user-section__title">My Position</span>
        <IonIcon
          icon={collapsed ? chevronDownOutline : chevronUpOutline}
          className="leaderboard-current-user-section__toggle-icon"
          aria-hidden="true"
        />
      </button>

      {!collapsed && (
        <div className="leaderboard-current-user-card">
          <div className="leaderboard-current-user-card__avatar" aria-hidden="true">
            {avatarText}
          </div>

          <div className="leaderboard-current-user-card__left">
            <div className="leaderboard-current-user-card__name">
              {isPrivateLeaderboardPlayerName(player) ? (
                <LeaderboardPlayerName name={player} />
              ) : (
                <TextMarquee text={player} />
              )}
            </div>
            <div className="leaderboard-current-user-card__rank-row">
              <span className="leaderboard-current-user-card__rank-label">Rank.</span>
              <span className="leaderboard-current-user-card__rank-value">
                {rank > 0 ? rank : 'N/A'}
              </span>
            </div>
          </div>

          <div className="leaderboard-current-user-card__right">
            <div className="leaderboard-current-user-card__metric-label">{metricLabel}</div>
            <div className="leaderboard-current-user-card__metric-value">{metricValue}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardCurrentUserCard;
